import React, {useEffect} from 'react';
import {useNavigate, useSearchParams} from "react-router-dom";
import useBookingSearchContext from "../../modules/booking/hooks/useBookingSearchContext";
import Loader from "../../modules/ui/shared/Loader/Loader";
import useBookingByPrebookingInternalIdGet from "../../modules/booking/hooks/useBookingByPrebookingInternalIdGet";

const PageSubscriptionPaymentProcessed = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const {setPrebookingId} = useBookingSearchContext();

    let prebookingInternalId = searchParams.get('r') || "";
    if (prebookingInternalId.length > 36) {
        prebookingInternalId = prebookingInternalId.substring(0, 36);
    }

    const { isError } = useBookingByPrebookingInternalIdGet(
        prebookingInternalId,
        {
            onSuccess: (bookings) => {
                if (bookings.length === 0) {
                    setPrebookingId(null);
                    navigate(`/checkout?error=1`);
                    return;
                }
                setPrebookingId(null);
                navigate(`/book-ok/${bookings[0].internalId}`)
            }
        }
    );

    useEffect(() => {
        if (isError) {
            setPrebookingId(null);
            navigate(`/checkout?error=1`)
        }
    }, [isError]);

    return (
        <div className="flex items-center justify-center w-full h-screen">
            <Loader/>
        </div>
    );
};

export default PageSubscriptionPaymentProcessed;
